module.exports = __webpack_public_path__ + "img/pikantesuppeohnehintergrund.ce4d1678.png";